import ConceptImageInput from './ConceptImageInput'

export default ConceptImageInput 